export default "__VITE_ASSET__CSV_2FoR__"